const enhanceProduct = (products) => {
  if (!products) return [];

  return products.map(product => {
      const raw = product?.raw || {};
      const priceDiscountPercentage = raw.price_discountpercentage ?? 0;
      const priceDiscountPercentage6001 = raw.price_discountpercentage_6001 ?? 0;

      const isOnDiscount = priceDiscountPercentage > 0;
      const hasExclusivePrice = (
          (priceDiscountPercentage6001 > 0 && priceDiscountPercentage === 0) ||
          priceDiscountPercentage6001 !== priceDiscountPercentage
      );

      return {
          id: raw.permanentid,
          onlinefrom: raw.onlinefrom,
          image: raw.imageurl?.trim(),
          name: raw.shortname || product?.Title,
          regularPrice: raw.price_regular,
          specialPrice: raw.price_discounted,
          lowestPrice: raw.lowest_price,
          isOnDiscount,
          hasExclusivePrice,
          inStock: raw.stock,
          excerpt: product?.excerpt,
          rating: product?.rating,
          genericType: raw.classification_productgenerictype,
          specificType: raw.classification_productspecifictype,
          handle: raw.shortname,
          coveoData: product // Original Coveo response for analytics
      };
  });
};

export default enhanceProduct;
